module.exports = __webpack_public_path__ + "static/img/banner1@2x.eade8d9.webp";


//////////////////
// WEBPACK FOOTER
// ./static/webp1/banner1@2x.webp
// module id = DNo+
// module chunks = 1